import "./TextField.css";
import { useId } from "react";

export default function TextField(props) {
  const id = useId();
  const invalid = Boolean(props.error);

  return (
    <div className={`field col${props.disabled ? " field-locked" : ""}`}>
      <div className="field-top row">
        <label className="field-label t-label" htmlFor={id}>
          {props.label}
          {props.requiredTag === true ? (
            <span className="field-required-tag t-eyebrow">Required</span>
          ) : props.requiredTag === false ? (
            <span className="field-required-tag t-eyebrow">Optional</span>
          ) : null}
        </label>
        {props.hint ? <span className="field-hint t-mono">{props.hint}</span> : null}
      </div>

      <div className={`field-box row${invalid ? " field-box-invalid" : ""}`}>
        <input
          id={id}
          className={`field-input${props.mono ? " t-mono field-input-mono" : ""}`}
          type={props.type || "text"}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && props.onSubmit) props.onSubmit();
          }}
          placeholder={props.placeholder}
          disabled={props.disabled}
          spellCheck="false"
          autoComplete="off"
          aria-invalid={invalid}
          aria-describedby={props.error || props.help ? `${id}-msg` : undefined}
        />
        {props.suffix ? <div className="field-suffix row">{props.suffix}</div> : null}
      </div>

      {props.error || props.help ? (
        <p
          id={`${id}-msg`}
          className={`field-msg t-body-sm${invalid ? " field-msg-error" : ""}`}
          role={invalid ? "alert" : undefined}
        >
          {props.error || props.help}
        </p>
      ) : null}
    </div>
  );
}
